﻿export class SearchOfflineDebates {
    languageId: number;
    pageNumber: number;
    pageSize: number;
    debateStatusId: number;
    search: string;
    isDesc: boolean;
    column: string;
}

